<pdq-table
  selectionType=""
  [activeRowId]="activeRowId"
  (onRowClick)="handleRowClick($event)"
  [columnsSettings]="columns"
  [rows]="rows"></pdq-table>
